import { render, staticRenderFns } from "./CompProfileEditChildren.vue?vue&type=template&id=4d46134a&scoped=true"
import script from "./CompProfileEditChildren.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileEditChildren.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d46134a",
  null
  
)

export default component.exports